import type { components } from "@/api/schema";

export type BackfillJob = components["schemas"]["BackfillJob"];
export type BackfillWindow = BackfillJob["window"];
export type BackfillMarketplace = BackfillJob["marketplaces"][number];

/** Menu order — mirrors the BE `window` enum. */
export const BACKFILL_WINDOWS: readonly BackfillWindow[] = ["1h", "6h", "1d", "7d", "30d", "90d"];

/** Active = the worker may still change it; drives polling and the progress view. */
export function isJobActive(status: BackfillJob["status"]): boolean {
  return status === "queued" || status === "running";
}

/** Orders ingested across all marketplaces (the "N orders" in toasts and freshness). */
export function ingestedTotal(job: BackfillJob): number {
  return job.marketplaces.reduce((sum, m) => sum + m.ingested, 0);
}
